export default {
  getRoutes: (prefix) => [
    {
      path: 'details',
      name: `${prefix}-content-details`,
      component: () => import('@/views/content-profile/DetailsTab.vue'),
    },
    {
      path: 'supportmaterials',
      name: `${prefix}-content-support-materials`,
      component: () => import('@/views/content-profile/SupportMaterialsTab.vue'),
    },
    {
      path: 'interactions',
      name: `${prefix}-content-interactions`,
      component: () => import('@/views/content-profile/InteractionsTab.vue'),
    },
    {
      path: 'quiz',
      name: `${prefix}-content-quiz`,
      component: () => import('@/views/content-profile/QuizTab.vue'),
      redirect: { name: `${prefix}-quiz-details` },
      children: [
        {
          path: 'details',
          name: `${prefix}-quiz-details`,
          component: () => import('@/views/content-profile/quiz/QuizDetailsTab.vue'),
        },
        {
          path: 'questions',
          name: `${prefix}-quiz-questions`,
          component: () => import('@/views/content-profile/quiz/QuizQuestionsTab.vue'),
        },
      ],
    },
    {
      path: 'captions',
      name: `${prefix}-content-captions`,
      component: () => import('@/views/content-profile/CaptionsTab.vue'),
    },
  ],
};
